import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"

export const ArrowLeft = (props) => {
  return <FontAwesomeIcon faIcon={faArrowLeft} {...props} />
}
